// extracted by mini-css-extract-plugin
module.exports = {"step":"step_step__gEVlX","title":"step_title__2EQgP","text":"step_text__3Dyzf","nav":"step_nav__2zJdJ","current":"step_current__3BHyV","optional":"step_optional__3rarQ"};